<template>
    <div class="page">
        <p>{{ date }}</p>
        <p>
            {{ userStore.user.firstname }} {{ userStore.user.lastname }}
            <br /> {{ userStore.user.address }}
            <br /> {{ userStore.user.city }}, {{ userStore.user.state }} {{ userStore.user.zipcode }}
            <br />SSN: {{ userStore.user.ssn }} | DOB: {{ userStore.user.dob }}
        </p>
        <p>
            {{ creditBureau.address_name }} <br />
            {{ address.street }} <br />
            {{ address.city }}, {{ address.state_abbreviation }}
            {{ address.zipcode }}
        </p>
        <p class="letter-content">
            Subject: Final Notice Before Legal Action for Disputed Items on Credit Report
        </p>
        <p class="letter-content">
            To Whom It May Concern,
        </p>
        <p class="letter-content">
            This communication serves as my third and final written notice and warning regarding disputed entries on my credit report.
            Please be informed that I am fully prepared to initiate legal proceedings under the Fair Credit Reporting Act (FCRA) to assert
            my rights and seek all possible damages as stipulated in Sections 616 and 617 due to your persistent noncompliance.
        </p>
        <p class="letter-content">
            Despite my previous two requests, the items I challenged remain on my credit report, contrary to the requirements of federal law.
            The FCRA obligates you to possess and provide original documentation from the creditor to substantiate the entries. Your written
            responses have indicated these items as "verified," yet you have neither disclosed the verifier's identity nor provided any of the
            original documentation, specifically a signed consumer contract, as mandated by Sections 609(a)(1)(A) and 611(a)(1)(A). Additionally,
            you have not detailed the method of verification, which is a requirement under Section 611(a)(7). It is your duty under Section 611(5)(A)
            of the FCRA to "promptly DELETE all information which cannot be verified."
        </p>
        <p class="letter-content">
            The FCRA clearly defines the civil liabilities and remedies available to consumers for noncompliance. As a consumer who understands their rights and is prepared to defend them through litigation, I expect you to take immediate action.
        </p>

        <p class="letter-content">
            The accounts listed below must be either verified or removed without delay:
        </p>
        <p v-for="creditor in reportStore.getSelectedAccounts(1, creditBureau.id)">
            <strong>
                {{ creditor.furnisher_name }} with account number
                <template v-if="creditor.reference_number">
                    {{ creditor.reference_number }}
                </template>
                <template v-else>
                    {{ creditor.account_number }}
                </template>
                <template v-if="creditor.reason">
                    <br />
                    {{ creditor.reason }}
                </template>
            </strong>
        </p>
        <p class="letter-content">
            I trust that you will address this matter with the urgency and seriousness it warrants.
        </p>
        <p>
            Sincerely
            <br />
            <br />
            {{ userStore.user.firstname }} {{ userStore.user.lastname }}
            <br>
        </p>
        <div class="page-content">
            <h1 style="padding: 0rem; 3rem; text-align: center;">Enclosures</h1>
            <p style="padding-top:3rem; text-align: center;">
                <img v-if='userStore.user.ssn_image_url' v-bind:src='userStore.user.ssn_image_url' width='300' height='200' />
                <img v-if='userStore.user.identity_image_url' v-bind:src='userStore.user.identity_image_url' width='300' height='200' />
            </p>
            <p v-if='userStore.user.address_verify_image_url'>
                <img v-bind:src='userStore.user.address_verify_image_url' width='300' height='200' />
            </p>
        </div>
    </div>
</template>
<script>
    import { ref, reactive, computed } from 'vue'
    import { useUserStore } from '../../stores/UserStore.js'
    import { useReportStore } from '../../stores/ReportStore.js'
    import moment from 'moment';
    export default {
        props: {
            creditBureau: {
                type: [Array, Object]
            },
        },
        setup(props) {
            const address = _.find(props.creditBureau.addresses, { 'id': props.creditBureau.selected_address });
            return {
                date: ref(moment().format('LL')),
                userStore: useUserStore(),
                reportStore: useReportStore(),
                _: _,
                address,
            };
        },
    };
</script>
